module.exports = __webpack_public_path__ + "img/tarjeta_image_preview.6e8cc3a.png";